/** Interfaces */
import { DatadogInterface } from '@core/interfaces/datadog.interface';

export class Datadog implements DatadogInterface {
  /**
   * Enable Datadog metrics collection
   */
  enabled: boolean;

  /**
   * The Datadog site of your organization, same value as agent site configuration.
   */
  site: string;

  /**
   * The RUM application ID.
   */
  applicationId: string;

  /**
   * A Datadog client token.
   */
  clientToken: string;

  /**
   * The application's service name.
   */
  service: string;

  /**
   * The percentage of sessions to track: 100 for all, 0 for none.
   */
  sampleRate: number;

  /**
   * Enables automatic collection of users actions.
   */
  trackInteractions: boolean;

  /**
   * Creates an instance of environment Datadog.
   *
   * @param  jsonData the environment Datadog
   */
  constructor(jsonData: DatadogInterface) {
    this.enabled = jsonData.enabled;
    this.site = jsonData.site;
    this.applicationId = jsonData.applicationId;
    this.clientToken = jsonData.clientToken;
    this.service = jsonData.service;
    this.sampleRate = jsonData.sampleRate;
    this.trackInteractions = jsonData.trackInteractions;
  }
}
